exports.GOOD_UNIT = [
  { label: "份", value: "份" },
  { label: "个", value: "个" },
  { label: "箱", value: "箱" },
  { label: "盒", value: "盒" },
  { label: "袋", value: "袋" },
  { label: "把", value: "把" },
  { label: "包", value: "包" },
  { label: "根", value: "根" },
  { label: "块", value: "块" },
  { label: "套", value: "套" },
  { label: "条", value: "条" },
  { label: "扎", value: "扎" },
  { label: "只", value: "只" },
  { label: "组", value: "组" },
  { label: "片", value: "片" },
  { label: "瓶", value: "瓶" },
  { label: "罐", value: "罐" },
  { label: "提", value: "提" },
  { label: "杯", value: "杯" },
  { label: "桶", value: "桶" },
  { label: "排", value: "排" },
];
exports.GOOD_WEIGHT_UNIT = [
  { label: "g", value: "g" },
  { label: "kg", value: "kg" },
];
exports.GOOD_BASIC_SPEC = [];
exports.CHANNCEL = [
  { label: "京东秒送", value: 1 },
  { label: "美团外卖", value: 2 },
  { label: "饿了么", value: 3 },
];

exports.CHANNCEL_NEW = [
  { label: "京东秒送", value: 1 },
  { label: "美团外卖", value: 2 },
  { label: "饿了么", value: 32 },
  { label: "饿了么星选", value: 31 },
];

exports.COMMON_SELECT = [
  {
    label: "是",
    value: "1",
  },
  {
    label: "否",
    value: "2",
  },
];
exports.BUSINESS_TYPE = [
  { value: "1", label: "商超" },
  { value: "2", label: "代买菜" },
];

exports.EXPORT_TIP = "导出已在后台运行，可以稍后在导出记录查看";

// 表格设置粘性头部和滚动条时，头部和滚动条的位移 - 通用设置
exports.TABLE_STICKY_OFFSET_COMMON = { offsetHeader: 56, offsetScroll: 56 };
// 表格设置粘性头部和滚动条时，头部和滚动条的位移 - 头部设置
exports.TABLE_STICKY_OFFSET_HEAD = { offsetHeader: 56 };

exports.TAB_LIST = [
  {
    label: "首页",
    key: "home",
    logId: "ofHomePage",
  },
  {
    label: "商超版",
    key: "supermarkets",
    logId: "ofSupermarketVersion",
  },
  {
    label: "前置仓版",
    key: "front-warehouse",
    logId: "frontWarehouseVersion",
  },
  // {
  //   label: "外卖版",
  //   key: "take-out-v",
  //   logId: "ofPrinterVersion",
  // },
  {
    label: "无人仓",
    key: "no-warehouse",
    logId: "automatedWarehouse",
  },
  {
    label: "开放平台",
    key: "open",
    logId: "func_openPlatform",
  },
  {
    label: "关于我们",
    key: "about",
    logId: "aboutUs",
  },
];
